import { useState } from 'react'

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Dialog, DialogContent, IconButton, Table, TableBody, TableCell, TableRow, Tooltip } from '@mui/material'

import { FplDialogTitle } from 'components/common'

const columnDescriptions: Array<{ column: string; meaning: string }> = [
  { column: 'Enabled', meaning: 'Controls whether this scheduler is enabled for the current booking.' },
  {
    column: 'Global',
    meaning:
      'Indicates whether this scheduler is enabled at application level. If disabled globally, it cannot run for this booking.',
  },
  { column: 'Scheduler', meaning: 'The scheduler/reminder type.' },
  {
    column: 'Context (Driver ID)',
    meaning:
      'The target of the latest scheduler chain. For stop-based schedulers this includes the job type, postcode and driver ID.',
  },
  {
    column: 'Initialized',
    meaning: 'Indicates whether this scheduler has created at least one attempt for the booking.',
  },
  {
    column: 'Current Status',
    meaning: 'Status of the latest scheduler-attempt record, including scheduled, sent or cancelled attempts.',
  },
  { column: 'Last Attempt', meaning: 'Date and time of the most recent attempt that was actually processed.' },
  {
    column: 'Last Outcome',
    meaning:
      'Outcome/status of the most recent processed attempt. This may differ from Current Status when another retry is scheduled or cancelled afterwards.',
  },
  {
    column: 'Retries',
    meaning:
      'Number of retries in the current scheduler chain. This can reset when the scheduler context changes, for example when the driver changes.',
  },
  {
    column: 'Next Attempt',
    meaning: 'Date and time of the next currently scheduled retry. Blank when no retry is scheduled.',
  },
]

const BookingSchedulerControlsColumnsMeaning = () => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Tooltip title='Column meanings'>
        <IconButton size='small' onClick={() => setOpen(true)}>
          <InfoOutlinedIcon fontSize='small' />
        </IconButton>
      </Tooltip>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth='md'>
        <FplDialogTitle id='scheduler-columns-info-dialog' onClose={() => setOpen(false)}>
          Column Meanings
        </FplDialogTitle>
        <DialogContent>
          <Table size='small'>
            <TableBody>
              {columnDescriptions.map(({ column, meaning }) => (
                <TableRow key={column}>
                  <TableCell sx={{ fontWeight: 600, verticalAlign: 'top' }}>{column}</TableCell>
                  <TableCell>{meaning}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default BookingSchedulerControlsColumnsMeaning
